/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_User_GuideInputs */

const en_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online User Guide`)
};

const fr_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide de l'utilisateur en ligne`)
};

const de_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online-Benutzerhandbuch`)
};

const it_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida utente online`)
};

const ru_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Онлайн-руководство пользователя`)
};

const es_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía del usuario en línea`)
};

const zh_cn2_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线用户指南`)
};

const ja_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインユーザーガイド`)
};

const hi_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑनलाइन उपयोगकर्ता मार्गदर्शिका`)
};

const pt_pt2_online_user_guide = /** @type {(inputs: Online_User_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia do usuário online`)
};

/**
* | output |
* | --- |
* | "Online User Guide" |
*
* @param {Online_User_GuideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const online_user_guide = /** @type {((inputs?: Online_User_GuideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_User_GuideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_online_user_guide(inputs)
	if (locale === "de") return de_online_user_guide(inputs)
	if (locale === "it") return it_online_user_guide(inputs)
	if (locale === "ru") return ru_online_user_guide(inputs)
	if (locale === "es") return es_online_user_guide(inputs)
	if (locale === "zh-CN") return zh_cn2_online_user_guide(inputs)
	if (locale === "ja") return ja_online_user_guide(inputs)
	if (locale === "hi") return hi_online_user_guide(inputs)
	if (locale === "pt-PT") return pt_pt2_online_user_guide(inputs)
	return en_online_user_guide(inputs)
});